import type { Dayjs, Dayjs as DayjsType, ManipulateType, PluginFunc } from 'dayjs';

declare module 'dayjs' {
  interface Dayjs {
    addVal: DayjsType['add'];
    subtractVal: DayjsType['subtract'];
    startOfQuarter(): DayjsType;
    endOfQuarter(): DayjsType;
    addQuarters(value: number): DayjsType;
    subtractQuarters(value: number): DayjsType;
  }
}

const compareOffset = (standard: Dayjs, compare: Dayjs): number => {
  // 현재 시간의 오프셋과 표준 시간대의 오프셋을 비교
  // 현재 시간 기준으로 상대 시간을 구할때 사용 ex) DatePreset 등
  const compareOffset = compare.tz().utcOffset();
  const standardOffset = standard.tz().utcOffset();

  return standardOffset - compareOffset;
};

const getRelativeDSTDayjs = (standard: Dayjs, compare: Dayjs): Dayjs => {
  const offset = compareOffset(standard, compare);
  return compare.add(offset, 'minute').tz();
};

const dayjsExtension: PluginFunc = (_options, dayjsClass) => {
  dayjsClass.prototype.addVal = function (value: number, unit: ManipulateType) {
    const compare = this.add(value, unit);
    return getRelativeDSTDayjs(this, compare);
  };

  dayjsClass.prototype.subtractVal = function (
    value: number,
    unit: ManipulateType,
  ) {
    const compare = this.add(-value, unit);
    return getRelativeDSTDayjs(this, compare);
  };

  dayjsClass.prototype.startOfQuarter = function () {
    const month = this.month();
    const quarterStartMonth = Math.floor(month / 3) * 3;
    return this.startOf('month').month(quarterStartMonth);
  };

  dayjsClass.prototype.endOfQuarter = function () {
    const month = this.month();
    const quarterEndMonth = Math.floor(month / 3) * 3 + 2;
    return this.startOf('month').month(quarterEndMonth).endOf('month');
  };

  dayjsClass.prototype.addQuarters = function (value: number) {
    const compare = this.add(value * 3, 'month');
    return getRelativeDSTDayjs(this, compare);
  };

  dayjsClass.prototype.subtractQuarters = function (value: number) {
    const compare = this.subtract(value * 3, 'month');
    return getRelativeDSTDayjs(this, compare);
  };
};

export default dayjsExtension;
